export const MODULE_ID = "VirtoCommerce.CustomerReviews";
export const ENABLED_KEY = "CustomerReviews.CustomerReviewsEnabled";

export const PAGE_SIZE = 5;
export const MAX_RATING = 5;

export const DEFAULT_REVIEW_IMAGES_SCOPE: string = "review-images";

export const DEFAULT_DESKTOP_DISPLAY_SLIDES_PER_REVIEW: number = 5;
export const DEFAULT_MOBILE_DISPLAY_SLIDES_PER_REVIEW: number = 2;
